import {
    BooleanField,
    Show,
    TextField,
    SimpleShowLayout,
    DateField,
    UrlField,
    NumberField,
    SelectField,
    ShowActions,
    RichTextField,
  } from "react-admin";
import {FileInput} from "../fileinputs/eventFileUpload";
  
  export const PaintingShow = (props) => {
    return (
      <Show {...props} >
        <SimpleShowLayout   >
           <TextField  source="title" />
           <RichTextField  source="description" />
           <FileInput source="images" title="Uploaded Files" />
        </SimpleShowLayout>
      </Show>
    );
  };
  